import { render } from "./15Footer.vue?vue&type=template&id=3eaa1c96&scoped=true"
import script from "./15Footer.vue?vue&type=script&lang=js"
export * from "./15Footer.vue?vue&type=script&lang=js"

import "./15Footer.vue?vue&type=style&index=0&id=3eaa1c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eaa1c96"]])

export default __exports__